<template>
  <div class="navbar" >
    <router-link class="navbar-link" to="/"><img src="@/assets/img.png"/></router-link>
    <div class="menu" style="float: right;">
      <el-menu
        style="float: right"
        background-color="#f8f8f8"
        :default-active="activeMenu"
        mode="horizontal"
        @select="selectMenuItem"
        :collapse="collapse"
      >
        <template v-for="item in menuData" v-if="isLoggedIn">
          <RecursiveMenu
            :key="item.name"
            :router-info="item"
          />
        </template>
        <el-menu-item index="login" v-if="!isLoggedIn" @click="login">{{ $t('login') }}</el-menu-item>
        <el-submenu index="user" v-else>
          <template slot="title">({{ LoginName }})</template>
          <el-menu-item index="user-center" @click="center">{{ $t('personal_center') }}</el-menu-item>
          <el-menu-item index="user-logout" @click="logout">{{ $t('logout') }}</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
    <div class="nav-bar menu-btn" v-if="!isLoggedIn" style="margin-top: 25px;">
      <span @click="login"  style="cursor:pointer; top: 100px">{{ $t('login') }}</span>
    </div>
    <div v-else class="nav-bar menu-btn">
      <span @click="drawer = true" class="iconfont" style="cursor:pointer;"> &#xe65d;</span>
      <el-drawer
        :visible.sync="drawer"
        direction="ttb"
        :modal="false"
        size="70%"
      >
        <el-menu
          class="el-menu-vertical-demo"
          background-color="#f8f8f8"
          :default-active="activeMenu"
          @select="selectMenuItem"
          :unique-opened=true
        >
          <template v-for="item in menuData">
            <RecursiveMenu
              :key="item.name"
              :router-info="item"
            />
          </template>
          <el-menu-item index="login" v-if="!isLoggedIn" @click="login">{{ $t('login') }}</el-menu-item>
          <el-submenu index="user" v-else>
            <template slot="title">({{ LoginName }})</template>
            <el-menu-item style="width: 50px" index="user-center" @click="center">{{ $t('personal_center') }}</el-menu-item>
            <el-menu-item style="width: 50px" index="user-logout" @click="logout">{{ $t('logout') }}</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import RecursiveMenu from "./recursive";

export default {
  components:{
    RecursiveMenu
  },
  data() {
    return {
      drawer: false,
      collapse: window.innerWidth <= 768, // 设置初始值，根据屏幕宽度判断是否折叠
      activeMenu: '', // 默认选中的菜单项
    };
  },
  computed: {
    menuData() {
      let baseRouter = this.$store.getters.baseRouter
      if (baseRouter && baseRouter.length > 0){
        return this.$store.getters.baseRouter[0].children
      }
      return this.$store.getters.baseRouter
    },
    isLoggedIn() {
      return this.$store.getters.token;
    },
    LoginName() {
      return this.$store.getters.name
    }
  },
  provide(){
    return {
      closeDialog: this.closeDialog
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.collapse = window.innerWidth <= 768;
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },

    renderMenuItems(items, parentIndex = '') {
      return items.map((item, index) => {
        const itemIndex = parentIndex ? `${parentIndex}-${index}` : index.toString();
        return {
          label: item.label,
          index: itemIndex,
          children: item.children ? this.renderMenuItems(item.children, itemIndex) : null
        };
      });
    },

    selectMenuItem(index, _, ele, aaa) {
      const query = {}
      const params = {}
      this.$store.getters.routeMap[index] && this.$store.getters.routeMap[index].parameters &&
      this.$store.getters.routeMap[index].parameters.forEach((item) => {
        if (item.type === 'query') {
          query[item.key] = item.value
        } else {
          params[item.key] = item.value
        }
      })
      if (index === this.$route.name) return
      if (index.indexOf('http://') > -1 || index.indexOf('https://') > -1) {
        window.open(index)
      } else {
        this.$router.push({ name: index, query, params })
      }
    },

    closeDialog(){
      this.drawer = false
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      await this.$router.push("/")
      this.reload()
    },
    login() {
      this.closeDialog()
      this.$router.push("/login")
    },
    center() {
      this.closeDialog()
      this.$router.push("/center")
    },
    async getProduct() {

    }
  }
}
</script>

<style>
.navbar {
  //height: 70px;
  background-color: #f8f8f8;
  padding: 0 0 0 0;
  border-bottom:1px solid #e7e7e7;
  /*display: flex;*/
  align-items: center;
}
.navbar img {
  width: 270px;
  height: 70px;
}

.el-submenu__title {
  padding: 2px 7px;
}

.el-menu-item {
  min-width: 20px !important;
}

.el-menu--popup {
  min-width: 20px !important;
}


.menu-btn {
  display: none;
  float:right;
  margin-top: 0%;
  border: 0;
  border-radius: 5px;
  width: 40px;
  height: 40px;
}

.menu-btn .iconfont {
  font-size: 50px;
  color: #2c2929;
}


@media screen and (max-width: 1030px){
  .navbar {
    padding: 0 5%;
    overflow: hidden;
  }
  .navbar img {
    width: 80%;
    height:100%;
  }
  .menu {
    display: none
  }
  .navbar-link{
    float: left;
    width: 50%
  }
  .menu-btn {
    display: inline;
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/components/Navbar1.vue